import * as React from "react"
import { NewsContentProps } from "@components/NewsContent/types"
import {
    ArticleContainer,
    ArticleWrapper,
    LeftArticleColumn,
    RightArticleColumn,
    StickySidebar
} from "@components/NewsContent/styles"
import slugify from "@utils/slugify"
import { useRef } from "react"

const NewsContent = ({ backgroundStyle, sections }: NewsContentProps) => {
    const sectionsRef = useRef<HTMLDivElement[]>([])
    const sidebarRef = useRef<HTMLElement>()

    const anchorTitles = sections?.filter((section) => !!section.title && section.title !== "null")?.map((section) => ({
        slug: slugify(section.title),
        title: section.title
    }))

    const scrollTo = (id: string) => {
        if (sectionsRef?.current?.[id]) {
            const sidebarTop = sidebarRef?.current ? parseInt(getComputedStyle(sidebarRef.current)?.top || "0", 10) : 0
            const y = sectionsRef.current[id].getBoundingClientRect().top
                + window.scrollY - sidebarTop
            window.scrollTo({ top: y, behavior: "smooth" })
        }
    }

    return <ArticleWrapper background={backgroundStyle}>
        <ArticleContainer>
            {anchorTitles && anchorTitles.length > 0 && <LeftArticleColumn>
                <StickySidebar ref={sidebarRef}>
                    <p>In dit artikel</p>
                    <ul>
                        {anchorTitles.map(({ title, slug }) => (
                            <li key={slug}>
                                <button
                                    type="button"
                                    onClick={() => scrollTo(slug)}
                                >
                                    {title}
                                </button>
                            </li>
                        ))}
                    </ul>
                </StickySidebar>
            </LeftArticleColumn>}
            <RightArticleColumn>
                {sections?.map(({ title, content }) => {
                    const slug = slugify(title)
                    return <div
                        id={slug}
                        key={slug}
                        dangerouslySetInnerHTML={{ __html: content }}
                        ref={(el) => {
                            sectionsRef.current[slug] = el
                        }}
                    />
                })}
            </RightArticleColumn>
        </ArticleContainer>
    </ArticleWrapper>
}

export default NewsContent
